module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/email-57947c94979bc219f189a3a91035f7c9.svg";